import React from 'react';
import { ArrowRight, FlaskConical, Shield, Gauge, Cpu } from 'lucide-react';
import { Link } from 'react-router-dom';

const TechnologyPage = () => {
  const techSections = [
    { name: 'How Multi-Ion Works', href: '/multi-ion-technology/how-it-works', icon: FlaskConical, description: 'Understand our proprietary ion technology' },
    { name: 'Multi-Ion Animation', href: '/multi-ion-technology/animation', icon: Cpu, description: 'Visualize the technology at molecular level' },
    { name: 'Why Non-Lithium', href: '/multi-ion-technology/why-non-lithium', icon: Shield, description: 'The case for Multi-Ion technology' },
    { name: 'Performance Comparison', href: '/multi-ion-technology/comparison', icon: Gauge, description: 'Compare with traditional batteries' },
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Our <span className="text-emerald-400">Multi-Ion™ Technology</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Discover how Multi-Ion technology is revolutionizing industrial energy storage with superior performance, safety, and sustainability.
            </p>
          </div>

          {/* Quick Links */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {techSections.map((section) => {
              const Icon = section.icon;
              return (
                <Link
                  key={section.name}
                  to={section.href}
                  className="group p-6 bg-gray-800/50 rounded-2xl border border-gray-700 hover:border-emerald-500/50 hover:bg-emerald-500/5 transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mb-4 group-hover:bg-emerald-500/20 transition-colors">
                    <Icon className="w-7 h-7 text-emerald-400" />
                  </div>
                  <h3 className="text-white font-semibold text-lg mb-2 group-hover:text-emerald-400 transition-colors">{section.name}</h3>
                  <p className="text-gray-500 text-sm mb-4">{section.description}</p>
                  <span className="text-emerald-400 text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    Learn more <ArrowRight className="w-4 h-4" />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TechnologyPage;
